export default {
      id: "burger-usage",
      viewBox: "0 0 37 30",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#burger",
      toString: function () {
        return this.url;
      }
    }